module.exports = __webpack_public_path__ + "img/7_187.4714f7b2.png";